<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Dashboard
        <small>Summary</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>Dashboard</li>
        <li class="active">Summary</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <!-- Small boxes (Stat box) -->
      <div class="row">
        <!-- ./col -->
        <div class="col-lg-3 col-xs-6">
          <!-- small box -->
          <div class="small-box bg-yellow">
            <div class="inner">
              <h3>{{ unique_users }}</h3>

              <p>Users</p>
            </div>
            <div class="icon">
              <i class="ion ion-person-stalker"></i>
            </div>
            <!--<a href="#" class="small-box-footer">More info <i class="fa fa-arrow-circle-right"></i></a>-->
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-3 col-xs-6">
          <!-- small box -->
          <div class="small-box bg-aqua">
            <div class="inner">
              <h3>{{ referrals }}</h3>

              <p>Referrals</p>
            </div>
            <div class="icon">
              <i class="ion ion-iphone"></i>
            </div>
            <!--<a href="#" class="small-box-footer">More info <i class="fa fa-arrow-circle-right"></i></a>-->
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-3 col-xs-6">
          <!-- small box -->
          <div class="small-box bg-blue">
            <div class="inner">
              <h3>{{ redeemed_refferals }}</h3>

              <p> Redeemed Referrals</p>
            </div>
            <div class="icon">
              <i class="ion ion-home"></i>
            </div>
            <!--<a href="#" class="small-box-footer">More info <i class="fa fa-arrow-circle-right"></i></a>-->
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-3 col-xs-6">
          <!-- small box -->
          <div class="small-box bg-purple">
            <div class="inner">
              <h3>{{ feedback_given }}</h3>

              <p>Completed Feedback</p>
            </div>
            <div class="icon">
              <i class="ion ion-chatboxes"></i>
            </div>
            <!--<a href="#" class="small-box-footer">More info <i class="fa fa-arrow-circle-right"></i></a>-->
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 col-md-offset-3">
          <!-- LINE CHART -->
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Global</h3>
            </div>
            <div class="box-body">
              <div class="chart">
                <chartjs-horizontal-bar :datalabel="'Global'" :labels="labels" :data="[unique_users, referrals, /*referrals_without_facilities_with_locationid + referrals_without_facilities_without_locationid,*/ /* referrals_with_facilities_with_locationid + referrals_with_facilities_without_locationid, */ redeemed_refferals, feedback_given]" :bind="true" :backgroundcolor="bgcolors"></chartjs-horizontal-bar>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-md-offset-3">
          <!-- LINE CHART -->
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Weekly</h3>
            </div>
            <div class="box-body">
              <div class="chart">
                <chartjs-horizontal-bar :datalabel="'Weekly'" :labels="labels" :data="[weekly_unique_users, weekly_referrals, /*weekly_referrals_without_facilities_with_locationid + weekly_referrals_without_facilities_without_locationid,*/ /* weekly_referrals_with_facilities_with_locationid + weekly_referrals_with_facilities_without_locationid, */ weekly_redeemed_refferals, weekly_feedback_given]" :bind="true" :backgroundcolor="bgcolors"></chartjs-horizontal-bar>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->

        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-md-offset-3">
          <!-- LINE CHART -->
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Monthly</h3>
            </div>
            <div class="box-body">
              <div class="chart">
                <chartjs-horizontal-bar :datalabel="'Monthly'" :labels="labels" :data="[monthly_unique_users, monthly_referrals, /*monthly_referrals_without_facilities_with_locationid + monthly_referrals_without_facilities_without_locationid,monthly_referrals_with_facilities_with_locationid + monthly_referrals_with_facilities_without_locationid, */ monthly_redeemed_refferals, monthly_feedback_given]" :bind="true" :backgroundcolor="bgcolors"></chartjs-horizontal-bar>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->

        </div>
      </div>

      <!-- /.row -->

    </section>
    <!-- /.content -->
  </div>
</template>

<script>
  import {
    getGlobalFunnel, getSummaryWeekly, getSummaryMonthly /* getUnredeemedReferralsWithLocationID, getUnredeemedReferralsWithoutLocationID, getWeeklyUnredeemedReferralsWithLocationID, getWeeklyUnredeemedReferralsWithoutLocationID, getMonthlyUnredeemedReferralsWithLocationID, getMonthlyUnredeemedReferralsWithoutLocationID */
  }
    from '../../../utils/stats'

  export default {
    name: 'app-dashboard',
    data () {
      return {
        'unique_users': '',
        'referrals': '',
        'redeemed_refferals': '',
        // 'referrals_without_facilities_with_locationid': '',
        'referrals_with_facilities_with_locationid': '',
        // 'referrals_without_facilities_without_locationid': '',
        'referrals_with_facilities_without_locationid': '',
        'feedback_given': '',
        labels: ['users', 'referrals', /* 'referrals without facilities', 'referrals with facilities', */ 'redeemed referrals', 'completed feedback'],
        dataset: [16, 5, 3, 5],
        bgcolors: ['#f19c12', '#57c1f0', '#dd4c3a', '#52a75a', 'blue', 'purple'],
        'weekly_unique_users': '',
        'weekly_referrals': '',
        // 'weekly_referrals_without_facilities_with_locationid': '',
        'weekly_referrals_with_facilities_with_locationid': '',
        // 'weekly_referrals_without_facilities_without_locationid': '',
        'weekly_referrals_with_facilities_without_locationid': '',
        'weekly_redeemed_refferals': '',
        'weekly_feedback_given': '',
        'monthly_unique_users': '',
        'monthly_referrals': '',
        // 'monthly_referrals_without_facilities_with_locationid': '',
        'monthly_referrals_with_facilities_with_locationid': '',
        // 'monthly_referrals_without_facilities_without_locationid': '',
        'monthly_referrals_with_facilities_without_locationid': '',
        'monthly_redeemed_refferals': '',
        'monthly_feedback_given': ''
      }
    },

    mounted () {
      getGlobalFunnel().then((response) => {
        this.unique_users = response.data.accounts
        this.referrals = response.data.referrals
        this.redeemed_refferals = response.data.redemptions
        this.feedback_given = response.data.feedbacks
      })
      getSummaryWeekly().then((response) => {
        this.weekly_unique_users = response.data.accounts
        this.weekly_referrals = response.data.referrals
        this.weekly_redeemed_refferals = response.data.redemptions
        this.weekly_feedback_given = response.data.feedbacks
      })
      getSummaryMonthly().then((response) => {
        this.monthly_unique_users = response.data.accounts
        this.monthly_referrals = response.data.referrals
        this.monthly_redeemed_refferals = response.data.redemptions
        this.monthly_feedback_given = response.data.feedbacks
      })
      /* getUnredeemedReferralsWithLocationID().then((response) => {
        // this.referrals_without_facilities_with_locationid = response.data.withoutFacilities.length ? response.data.withoutFacilities.map(loc => Object.values(loc)[0].Referrals).reduce((a, c) => a + c) : 0
        this.referrals_with_facilities_with_locationid = response.data.withFacilities.length ? response.data.withFacilities.map(loc => Object.values(loc)[0].Referrals).reduce((a, c) => a + c) : 0
      })
      getUnredeemedReferralsWithoutLocationID().then((response) => {
        // this.referrals_without_facilities_without_locationid = response.data.withoutFacilities.length ? response.data.withoutFacilities.map(loc => Object.values(loc)[0].Referrals).reduce((a, c) => a + c) : 0
        this.referrals_with_facilities_without_locationid = response.data.withFacilities.length ? response.data.withFacilities.map(loc => Object.values(loc)[0].Referrals).reduce((a, c) => a + c) : 0
      })
      getWeeklyUnredeemedReferralsWithLocationID().then((response) => {
        // this.weekly_referrals_without_facilities_with_locationid = response.data.withoutFacilities.length ? response.data.withoutFacilities.map(loc => Object.values(loc)[0].Referrals).reduce((a, c) => a + c) : 0
        this.weekly_referrals_with_facilities_with_locationid = response.data.withFacilities.length ? response.data.withFacilities.map(loc => Object.values(loc)[0].Referrals).reduce((a, c) => a + c) : 0
      })
      getWeeklyUnredeemedReferralsWithoutLocationID().then((response) => {
        // this.weekly_referrals_without_facilities_without_locationid = response.data.withoutFacilities.length ? response.data.withoutFacilities.map(loc => Object.values(loc)[0].Referrals).reduce((a, c) => a + c) : 0
        this.weekly_referrals_with_facilities_without_locationid = response.data.withFacilities.length ? response.data.withFacilities.map(loc => Object.values(loc)[0].Referrals).reduce((a, c) => a + c) : 0
      })
      getMonthlyUnredeemedReferralsWithLocationID().then((response) => {
        // this.monthly_referrals_without_facilities_with_locationid = response.data.withoutFacilities.length ? response.data.withoutFacilities.map(loc => Object.values(loc)[0].Referrals).reduce((a, c) => a + c) : 0
        this.monthly_referrals_with_facilities_with_locationid = response.data.withFacilities.length ? response.data.withFacilities.map(loc => Object.values(loc)[0].Referrals).reduce((a, c) => a + c) : 0
      })
      getMonthlyUnredeemedReferralsWithoutLocationID().then((response) => {
        // this.monthly_referrals_without_facilities_without_locationid = response.data.withoutFacilities.length ? response.data.withoutFacilities.map(loc => Object.values(loc)[0].Referrals).reduce((a, c) => a + c) : 0
        this.monthly_referrals_with_facilities_without_locationid = response.data.withFacilities.length ? response.data.withFacilities.map(loc => Object.values(loc)[0].Referrals).reduce((a, c) => a + c) : 0
      }) */
    }
  }
</script>



// WEBPACK FOOTER //
// Dashboard.vue?5a855184